import React, { FC, useEffect, useRef, useState } from 'react'
import { Modal, Row, Table, Input, Col, Tabs, Timeline, Button,Image } from 'antd'
import { ColumnsType, TablePaginationConfig } from 'antd/es/table'
import { assetsListModel } from '../assetsListModel'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, getBaseImgLookUrl } from '@/utils/constants'
import { transPgToPagination } from '@/model/globalModel'
import { assetsListService, IAssetsListDetail } from '../assetsListService'
import { ISearchPage } from '@/types/AppTypes'
import { ModeType } from '@/model/navModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { YhFormBox } from '@/components/YhFormBox'
import { ClockCircleOutlined, SmileOutlined, SyncOutlined } from '@ant-design/icons'
import { spawn } from 'child_process'
import { useDictModel } from '@/views/base/dict/dictModel'
import YhTootip from '@/components/YhTootip'

const { Search } = Input

export const UserModal = () => {
    const { getSelectedDictOne,getTreeNodeName } = useDictModel(() => []);
    const { uesrVisible: visible, setUesrVisible, materialCodeRow,exportUser} = assetsListModel()
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: DEFAULT_FIRST_PAGE_NUM }
    const [dataSource, setDataSource] = useState<IAssetsListDetail[]>([])
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    const formRef = useRef<IYhFormRef>()

    useEffect(() => {
        if (visible) {
            loadData()
        }
    }, [visible])

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '物资图片',
            width: 140,
            align: "center",
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)}  style={{maxWidth:'50px',maxHeight:'70px'}}/> : null)
        },
        {
            title: '物资编码',
            width: 160,
            dataIndex: 'materialCode',
        },
        {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
        },
        {
            title: '物资类型',
            width: 160,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? ''
        },
        {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) =><YhTootip text={text} />,      
        },
        {
            title: '单价',
            width: 160,
            dataIndex: 'price',
        },
        {
            title: '单位',
            width: 160,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',                
        },
        {
            title: '数量',
            width: 160,
            dataIndex: 'num',
        },
        {
            title: '合计',
            width: 160,
            dataIndex: 'amount',
        },
        {
            title: '条形码',
            width: 160,
            dataIndex: 'barCode',
        },
        {
            title: '当前存放地点',
            width: 160,
            dataIndex: 'deposit',
        },
        {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        },
    ]


    const loadData = async (page: ISearchPage = initPgCfg) => {
        const searchParams = {
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            typeList:['assets.receive','assets.transfer'],
            userCode: materialCodeRow?materialCodeRow?.userCode:"",
        }
        let { retData } = await assetsListService.userPage(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
    }
    const onOk = () => {}

    return (
        <Modal
            visible={visible}
            title="使用人详情"
            onCancel={() => {
                setUesrVisible(false)
            }}
            onOk={onOk}
            width={1200}
        >
            <div style={{display:'flex',flexDirection: 'row',justifyContent: 'space-between',alignItems:'center'}}>
        <div><span style={{fontSize:'18px',fontWeight:'bolder'}}>所属部门：{materialCodeRow?.department} <span style={{marginLeft:'30px'}}>使用人：{materialCodeRow?.user}</span></span></div>
            <Button type="primary" shape="round" style={{margin:'10px 0 20px 0'}}  onClick={exportUser}>导出</Button></div>
             <Table
                rowKey={(record) => record.key}
                columns={columns}
                dataSource={dataSource}
                scroll={{ x: 'max-content' }}
                bordered
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true
                }}
            />
        </Modal>
    )
}
